<div class="inspire">
  <h1 class="large text-center">{{ 'landing.home.inspire.title' | translate }}</h1>
  <p class="text-center">{{ 'landing.home.inspire.subtitle' | translate }}</p>

  <div class="hidden xl:block">
    <p-carousel
      [value]="carouselUrls"
      [numVisible]="1"
      [numScroll]="1"
      [circular]="true"
      [showNavigators]="false"
      autoplayInterval="5000"
    >
      <ng-template let-urls #item>
        <div class="flex justify-content-between">
          @for (url of urls; track $index) {
            <img class="inspire-carousel-img" [src]="url" alt="Inspiration" />
          }
        </div>
      </ng-template>
    </p-carousel>
  </div>

  <div class="xl:hidden">
    <p-carousel
      [value]="carouselUrls.flat()"
      [numVisible]="1"
      [numScroll]="1"
      [circular]="true"
      [showNavigators]="false"
      autoplayInterval="5000"
    >
      <ng-template let-url #item>
        <img class="w-full" [src]="url" alt="Inspiration" />
      </ng-template>
    </p-carousel>
  </div>

  <div>
    <app-button
      customIconSrc="/assets/icons/stars.svg"
      [shadow]="false"
      size="x-large"
      color="pink"
      routerLink="project"
      [label]="'landing.home.inspire.cta' | translate">
    </app-button>
  </div>
</div>
